<div class="container-fluid h-100">
  <div class="row">
    <div class="col-12">
      <span class="title">{{ content.title }}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <p-divider styleClass="divider-m-5"></p-divider>
    </div>
  </div>
  <div class="container-fluid pb-3 container-content">
    <p class="coming-soon-text">Coming Soon!!</p>
    <!-- <img src="assets/images/ComingSoon_Image.png" alt="coming soon"> -->
  </div>
</div>
